import { faArrowUpFromBracket } from '@fortawesome/pro-light-svg-icons/faArrowUpFromBracket';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { THEME_CONSTANTS } from '../../../../../../../../../ui-components/services/button-theme-service';
import { messages } from '../messages';
import styles from '../style.module.less';

type NotUploadedStateProps = {
  fileTypesToShow: string;
};

export const NotUploadedState = ({ fileTypesToShow }: NotUploadedStateProps) => {
  return (
    <div className={styles['drag-drop-content']}>
      <FontAwesomeIcon className={styles['upload-icon']} icon={faArrowUpFromBracket} />
      <Text
        className={styles['drag-drop-text']}
        formattedMessageValues={{ types: fileTypesToShow }}
        textType={TextType.Paragraph}
        value={messages.dragDropPrompt}
      />
      <Text className={styles['or-text']} textType={TextType.Paragraph} value={messages.or} />
      <Button className={styles['select-file-button']} theme={THEME_CONSTANTS.primary}>
        <FormattedMessage {...messages.selectAFile} />
      </Button>
    </div>
  );
};
